<template>
  <span
    class="dui-book-cover"
    :class="{ 'square': vm.isSquare }"
  >
    <span
      class="cover-image"
      :style="{ 'background-image': vm.coverUrl ?
        'url(' + vm.coverUrl + ')' :
        '',
      }"
    />
  </span>
</template>

<script>
const MAX_SQUARE_RATIO = 1.28;

export default {
  props: {
    bookCoverUrl: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    imageEl: null,
    vm: {
      coverUrl: '',
      isSquare: false,
    },
  }),
  watch: {
    bookCoverUrl: function() {
      this.setupCoverType();
    },
  },
  mounted() {
    this.setupCoverType();
  },
  methods: {
    imageLoaded() {
      const ratio = this.imageEl.naturalHeight / this.imageEl.naturalWidth;
      this.$set(this.vm, 'isSquare', (ratio < MAX_SQUARE_RATIO));
      this.$set(this.vm, 'coverUrl', this.bookCoverUrl);
      delete this.imageEl;
    },
    setupCoverType() {
      if (!this.bookCoverUrl) {
        this.$set(this.vm, 'coverUrl', '');
        this.$set(this.vm, 'isSquare', false);
        return;
      }

      this.imageEl = new Image();
      this.imageEl.src = this.bookCoverUrl;
      this.imageEl.onload = this.imageLoaded.bind(this);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-book-cover {
  background: url('../../../assets/book-placeholder.svg') no-repeat getColor($white);
  background-size: cover;
  border-radius: $border-radius-lg;
  box-sizing: border-box;
  box-shadow: $box-shadow-sm;
  content: " ";
  display: inline-block;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;

  .cover-image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    content: " ";
    display: inline-block;
    height: 100%;
    width: 100%;
  }
}

a.dui-book-cover-link {
  display: flex;
  justify-content: center;
}
</style>
